import React from "react";
import { FileSearch, FileCheck, PieChart } from "lucide-react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

// The pay-breakdown action is relabelled per region — "CTC" is an India
// concept, so UK employees see "Salary Breakdown" and unknown "Pay Breakdown".
const breakdownLabel = (region) =>
  region === "India" ? "View CTC Breakdown"
  : region === "UK"  ? "View Salary Breakdown"
  :                    "View Pay Breakdown";

const ACTIONS = [
  { key: "correction", label: "Request Payslip Correction", icon: FileSearch, color: "border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90]" },
  { key: "income",     label: "Request Income Certificate",  icon: FileCheck,  color: "border-white/15 bg-white/5 text-white/50 hover:bg-white/10 hover:text-white" },
  { key: "ctc",        label: "View CTC Breakdown",          icon: PieChart,   color: "border-blue-500/25 bg-blue-500/8 text-blue-400/70 hover:bg-blue-500/15 hover:text-blue-400" },
];

export default function ActionPanel({ onCorrection, onIncome, onCTC, region = "India" }) {
  const handlers = { correction: onCorrection, income: onIncome, ctc: onCTC };
  const labelFor = (key) => (key === "ctc" ? breakdownLabel(region) : null);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Quick Actions</span>
      </div>
      <div className="p-4 space-y-2">
        {ACTIONS.map(({ key, label, icon: Icon, color }) => (
          <button key={key} onClick={handlers[key]}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border text-sm font-medium transition-colors text-left ${color}`}>
            <Icon size={15} className="shrink-0" />
            {labelFor(key) || label}
          </button>
        ))}
      </div>
    </div>
  );
}